import { lazy } from 'react';

// 使用懒加载导入所有页面组件
const Index = lazy(() => import('../pages/index/index'));
const AboutUs = lazy(() => import('../pages/AboutUs'));
const Solution = lazy(() => import('../pages/Solution'));
const Product = lazy(() => import('../pages/Product'));
const Operations = lazy(() => import('../pages/Operations'));
const Removal = lazy(() => import('../pages/Removal'));
const Reconfiguration = lazy(() => import('../pages/Reconfiguration'));
const DevOps = lazy(() => import('../pages/DevOps'));
const Repair = lazy(() => import('../pages/Repair'));



// 路由配置
const routes = [
  {//首页
    path: '/',
    key: 'index',
    element: <Index />,
    exact: true,
  },
  {//关于我们
    path: '/about', 
    key: 'about',
    element: <AboutUs />,
  },
  {//运维案例
    path: '/case/operations',
    key: 'operations',
    element: <Operations />,
  },
  {//搬迁
    path: '/case/removal',
    key: 'removal',
    element: <Removal />,
  },
  {//重新配置案例 
    path: '/case/reconfiguration',
    key: 'reconfiguration',
    element: <Reconfiguration />,
  },
  {//产品服务
    path: '/product',
    key: 'product',
    element: <Product />,
  },
  {//解决方案-交付
    path: '/solution/delivery',
    key: 'delivery',
    element: <Solution />,
  },
   {//解决方案-运维
    path: '/solution/devOps',
    key: 'devOps',
    element: <DevOps/>,
  },
  {//解决方案-维修
    path: '/solution/repair',
    key: 'repair',
    element: <Repair/>,
  },  
];

export default routes;